import React, { forwardRef } from 'react'
import SectionHeading from '../Heading/SectionHeading'
import styles from './sectionWithHeading.module.scss'

interface SectionWithHeadingProps {
  title: string
  afterTitle?: string
  color?: string
  children: React.ReactNode
}

const SectionWithHeading = forwardRef<HTMLDivElement, SectionWithHeadingProps>(
  ({ title, afterTitle, color, children }, ref) => {
    return (
      <div className={styles.section_wrapper} ref={ref}>
        <SectionHeading text={title} afterTitle={afterTitle} color={color} />
        <div className={styles.section_content}>{children}</div>
      </div>
    )
  }
)

export default SectionWithHeading
